import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  wrap: {
    display: 'flex',
    minHeight: '100vh',

    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      flexDirection: 'column',
    },
  },

  contentSection: {
    width: '100%',
    padding: '30px 60px',

    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      width: '100%',
      right: 0,
      padding: '0px',
    },
  },

  infoSection: {
    width: '50%',

    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      width: '100%',
      height: '600px',
    },
  },
  stackPosition: {
    position: 'relative',
    gap: 0,
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      top: '-60px',
    },
  },
  partnersSection: {
    marginBottom: '16px',
    maxWidth: 'calc(100vw - 452px)',
    [`@media (max-width: 990px)`]: {
      maxWidth: '100vw',
    },
  },
  backgroundHomepage: {
    height: '300px',
    width: '100%',
    backgroundColor: 'black',
    opacity: '0.4',
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      height: '210px',
    },
  },

  textHomepage: {
    height: '300px',
    width: '100%',
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      height: '210px',
    },
  },
  textOnImage: {
    height: 0,
    position: 'relative',
    top: '-310px',
    color: 'white',
    textAlign: 'center',
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      top: '-220px',
    },
  },
  background: {
    backgroundColor: 'white',
    gap: '0',
  },
  section: {
    height: '100%',
    display: 'flex',
    background: 'white',

    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      flexDirection: 'column',
    },
  },
}))
